import { render } from "./GoogleIntegrationView.vue?vue&type=template&id=22d06bf2&scoped=true"
import script from "./GoogleIntegrationView.vue?vue&type=script&lang=js"
export * from "./GoogleIntegrationView.vue?vue&type=script&lang=js"

import "./GoogleIntegrationView.vue?vue&type=style&index=0&id=22d06bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d06bf2"]])

export default __exports__